import React from "react";
import { logo_ss } from "../images";

//rafce

const Navbar = () => {
  return (
    <>
      <nav
        className="navbar sticky-top navbar-expand-sm navbar-light"
        style={{ backgroundColor: "white" }}
      >
        <div className="container-fluid ">
          <span className="navbar-brand">
            <img
              src={logo_ss}
              alt=""
              className="d-inline-block align-text-top main-logo"
            />
          </span>
          {/* <button
            className="navbar-toggler custom-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className="collapse navbar-collapse justify-content-end"
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav ">
              <li className="nav-item">
                <a
                  className="nav-link menu-item active"
                  aria-current="page"
                  href="#"
                >
                  Beranda
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link menu-item" href="#">
                  Tentang Kami
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link menu-item" href="#">
                  Produk
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link menu-item" href="#">
                  Lokasi
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link menu-item" href="#">
                  Blog
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link menu-item" href="#">
                  Kontak
                </a>
              </li>
            </ul>
          </div> */}
        </div>
      </nav>
    </>
  );
};

export default Navbar;
